const ucFirstAll = (s) => {
    if (s !== undefined) {
        const words = s.split(" ");

        for (let i = 0; i < words.length; i++) {
            words[i] = words[i][0].toUpperCase() + words[i].substr(1);
        }
        return words.join(" ");
    }
};

export { ucFirstAll };
